module.exports = __webpack_public_path__ + "static/img/pdarrow_right.0e0e17f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdarrow_right.png
// module id = Smrf
// module chunks = 2